import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';

import { listProperties } from '../../../core/constants/properties-const';
import { CaptureUnitProductModalComponent } from './capture-unit-product-modal/capture-unit-product-modal.component';

@Component({
  selector: 'app-capture-unit-product',
  templateUrl: './capture-unit-product.component.html',
  styleUrls: ['./capture-unit-product.component.scss'],
})
export class CaptureUnitProductComponent implements OnInit {
  constructor(public dialog: MatDialog) {}

  public titleModal = 'Tipo de Unidade';

  public unit;
  public listImoveis = listProperties;
  public unitString = '';
  public openDropDown = false;
  private type: any = {};

  ngOnInit(): void {}

  public openDropdown() {
    this.openDropDown = !this.openDropDown;
  }

  openDialog() {
    const data = {
      unit: this.unit ? this.unit : null,
      type: this.type.item ? this.type : null,
    };

    const dialogRef = this.dialog.open(CaptureUnitProductModalComponent, {
      height: '700px',
      width: '850px',
      data
    });

    this.openDropDown = false;

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.unit = result.value;
        this.listImoveis.forEach((i) => {
          i.listItems.forEach((item) => {
            if (item.code === this.unit.typeCode) {
              this.type.title = i.title;
              this.type.item = item.item;
              this.type.code = item.code;
            }
          });
        });

        this.unitString = `${this.type.title} / ${this.type.item} `;
        if (this.unit.total_area) {
          this.unitString += `/ ${this.unit.total_area}m² `;
        }
        if (this.unit.useful_area) {
          this.unitString += `sendo ${this.unit.useful_area}m² de área útil `;
        }
        if (this.unit.bedroom) {
          this.unitString += `/ ${this.unit.bedroom} dormitórios `;
        }
        if (this.unit.suite) {
          this.unitString += `/ ${this.unit.suite} vagas `;
        }
        if (this.unit.bathroom) {
          this.unitString += `/ ${this.unit.bathroom} banheiros `;
        }
        if (this.unit.car_spaces) {
          this.unitString += `/ ${this.unit.car_spaces} vagas `;
        }
      }
    });
  }

  closeDialog() {
    this.dialog.closeAll();
  }
}
